define('Cart.Item.Summary.View.Ext', [
    'Cart.Item.Summary.View'
  ], function (
      View
) {
    'use strict';
  
    return _.extend( View.prototype, {
        initialize: _.wrap( View.prototype.initialize, function (fn) {
            fn.apply(this, _.toArray(arguments).slice(1));
            var self = this;

            self.isMinimumOrder = !!self.model.get('item').get('custitem_mhi_min_order_qty');
            if ( self.isMinimumOrder ) {
                self.min = parseInt( self.model.get('item').get('custitem_mhi_min_order_qty'), 10 );
            } else {
                self.min = 1;
            }
        }),

        getContext: _.wrap( View.prototype.getContext, function (fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            var self = this;

            context.isMinimumOrder = self.min > 1;
            context.quantity = self.min;

            return context;
        })

    });

  });
  
